import React, { useContext } from 'react';
import { Switch, Box } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { ThemeContext } from '../../core/context/ThemeContext';

const ThemeToggle = () => {
  const { mode, toggleTheme } = useContext(ThemeContext);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LightMode sx={{ color: mode === 'light' ? '#fbbf24' : '#94a3b8' }} />
      <Switch
        checked={mode === 'dark'}
        onChange={toggleTheme}
        color="default"
      />
      <DarkMode sx={{ color: mode === 'dark' ? '#60a5fa' : '#94a3b8' }} />
    </Box>
  );
};

export default ThemeToggle;
